import { useState } from "react";
import { motion } from "framer-motion";

const DIMS = [
  { key: "direction", name: "Direction", q: "What matters most?", description: "The result and priorities people should act on." },
  { key: "standards", name: "Standards", q: "What does good work look like?", description: "What good work requires and what cannot be compromised." },
  { key: "ownership", name: "Ownership", q: "Who owns the result?", description: "Who carries the result and who takes the next step." },
  { key: "authority", name: "Authority", q: "What can people decide?", description: "Which decisions people can make without checking upward." },
  { key: "behaviour", name: "Behaviour", q: "How are people expected to act?", description: "How people and leaders are expected to act under pressure." },
];

export const ClarityField = () => {
  const [active, setActive] = useState("direction");
  const current = DIMS.find((dimension) => dimension.key === active);

  return (
    <div data-testid="clarity-field">
      <div className="hidden md:grid grid-cols-5 border border-rule">
        {DIMS.map((dimension) => (
          <button
            key={dimension.key}
            type="button"
            data-testid={`clarity-dim-${dimension.key}`}
            aria-pressed={active === dimension.key}
            onClick={() => setActive(dimension.key)}
            onMouseEnter={() => setActive(dimension.key)}
            className={`px-4 py-6 text-left border-r border-rule last:border-r-0 transition-colors duration-300 ${
              active === dimension.key ? "bg-terra text-white" : "text-ink hover:bg-ink/[0.03]"
            }`}
          >
            <span className="font-display text-xl tracking-tight">{dimension.name}</span>
          </button>
        ))}
      </div>
      <motion.div
        key={active}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="hidden md:block border-x border-b border-rule px-6 py-8"
      >
        <p data-testid="clarity-field-question" className="font-display text-2xl md:text-3xl tracking-tight">
          {current.q}
        </p>
        <p data-testid="clarity-field-description" className="mt-3 max-w-2xl text-sm leading-relaxed text-mute md:text-base">
          {current.description}
        </p>
      </motion.div>
      <div className="md:hidden border border-rule">
        {DIMS.map((dimension) => (
          <div key={dimension.key} className="px-5 py-5 border-b border-rule last:border-b-0">
            <h3 className="font-display text-xl text-terra tracking-tight">{dimension.name}</h3>
            <p className="mt-2 text-base text-mute">{dimension.q}</p>
            <p className="mt-2 text-sm leading-relaxed text-mute/80">{dimension.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
